import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/Login.css';

const Login = () => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  
  // Check if user is already authenticated
  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem('isAuthenticated') === 'true' || 
                           localStorage.getItem('isAuthenticated') === 'true';
    if (isAuthenticated) {
      navigate('/admin/dashboard');
    }
  }, [navigate]);

  // For demo purposes - replace with actual authentication in production
  const validCredentials = {
    username: 'admin',
    password: 'password123'
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({
      ...credentials,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    
    // Simulate API call with a timeout
    setTimeout(() => {
      // Simple authentication for demo purposes
      if (credentials.username === validCredentials.username && 
          credentials.password === validCredentials.password) {
        // Store authentication status based on remember me preference
        if (rememberMe) {
          localStorage.setItem('isAuthenticated', 'true');
        } else {
          sessionStorage.setItem('isAuthenticated', 'true');
        }
        // Redirect to admin dashboard
        navigate('/admin/dashboard');
      } else {
        setError('Invalid username or password');
        setIsLoading(false);
      }
    }, 800); // Simulate a short delay for API call
  };

  return (
    <div className="login-container">
      <div className="login-split-layout">
        {/* Left side - Image */}
        <div className="login-image-side">
          <div className="login-image-overlay">
            <div className="login-image-content">
              <h1>QR Code Digital Advisor</h1>
              <p>The Next Level of Digital Verification</p>
            </div>
          </div>
        </div>
        
        {/* Right side - Login Form */}
        <div className="login-form-side">
          <div className="login-card">
            <div className="login-header">
              <div className="mb-4 d-flex justify-content-center">
                <div className="logo-container">
                  <div className="company-logo-admin"></div>
                </div>
              </div>
              <h2>Admin Login</h2>
              <p className="text-muted">Access your dashboard</p>
            </div>
            
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
            
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="username" className="form-label">Username</label>
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="bi bi-person"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    id="username"
                    name="username"
                    value={credentials.username}
                    onChange={handleChange}
                    placeholder="Enter username"
                    required
                  />
                </div>
              </div>
              
              <div className="mb-3">
                <label htmlFor="password" className="form-label">Password</label>
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="bi bi-lock"></i>
                  </span>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    name="password"
                    value={credentials.password}
                    onChange={handleChange}
                    placeholder="Enter password"
                    required
                  />
                </div>
              </div>
              
              <div className="mb-4 form-check d-flex align-items-center">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  id="rememberMe"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                />
                <label className="form-check-label pt-1 small" htmlFor="rememberMe">
                  Remember me
                </label>
              </div>
              
              <button 
                type="submit" 
                className="btn btn-primary w-100" 
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Logging in...
                  </>
                ) : 'Login'}
              </button>
            </form>
            
            <div className="login-footer mt-3">
              <p className="text-muted small">© 2025 QR Code Digital Advisor</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
